import ImportReviewController from 'cio/pods/imports/import/setup/review/controller';
import { action, computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { task } from 'ember-concurrency';
import { inject as service } from '@ember/service';
import ImportModel, { UPDATE_TYPES, ImportState } from 'cio/models/import';

import RouterService from '@ember/routing/router-service';
import { hasNothingToImport } from 'cio/components/import-review/summary-message';

export default class SegmentsSegmentImportsCSvSetupReviewController extends ImportReviewController {
  @service router!: RouterService;

  @readOnly('model') import!: ImportModel;

  confirmAddingPeople = false;

  @computed('import.hasAllInvalidRows', 'import.validateMeta.{newProfiles,existingProfiles}')
  get hasNothingToImport() {
    return hasNothingToImport(this.import, this.importType?.value ?? '');
  }

  addPeople = task({ drop: true }, async () => {
    let record = this.import;

    if (record.state !== ImportState.Imported) {
      record.set('updateType', UPDATE_TYPES.import);
      await record.save();
    }

    this.router.transitionTo('segments.segment', record.belongsTo('segment').id());
  });

  confirmAndAddPeople = task({ drop: true }, async () => {
    let segment = await this.import.get('segment');

    if (segment.usedInActiveCampaignsOrUnsentNewsletters) {
      this.set('confirmAddingPeople', true);
    } else {
      await this.addPeople.perform();
    }
  });

  setDefaults() {
    this.set('confirmAddingPeople', false);
  }

  @action
  cancelImport() {
    let segmentId = this.import.belongsTo('segment').id();

    this.import.destroyRecord().then(() => {
      this.router.transitionTo('segments.segment', segmentId);
    });
  }
}
